(function () {
  'use strict';

  angular
    .module('service.account', [])

    /* @ngInject */
    .factory('AccountService', ["$rootScope", "AppService", "HttpService", "RoutesService", function ($rootScope, AppService, HttpService, RoutesService) {
      var _this = this;
      this.getLinks = function () {
        var _routes = RoutesService.get(),
          links = {};

        _.each(_routes, function (route, key) {
          if (key.indexOf('Account') >= 0) {
            links[key] = '/' + route.url;
          }
        });

        return links;
      };
      this.initAccount = function (ctrl) {
        ctrl.links = _this.getLinks();
        ctrl.logout = function () {
          $rootScope.$broadcast('logout');
        };
        _this.setManagement(ctrl);
        $rootScope.$broadcast('showPageLoader', false);
      };
      this.setManagement = function (ctrl) {
        AppService.getParams()
          .then(function (params) {
            ctrl.Account = _.cloneDeep(params.Account);
            ctrl.Account.hasServices = params.Account.IsManagementGiftCards || params.Account.IsManagementCredits || params.Account.IsManagementLoyaltyPoints || params.Account.IsManagementWishlistTracking;
            ctrl.Account.hasOrders = params.Account.IsManagementOrderTracking || params.Account.IsManagementInvoicesAndCreditsTracking || params.Account.IsManagementWebCartTracking || params.Account.IsManagementReturns || params.Account.IsManagementComplaint || params.Account.IsManagementNumericProducts;
          })
          .catch(function (error) {
            console.error(error);
          });
      };
      this.getOrders = function () {
        return HttpService.get({
          url: '/Account/GetOrders',
          cache: false
        })
        .then(function (response) {
          return response.results;
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.getOrder = function (id) {
        return HttpService.post({
          url: '/Account/GetOrder',
          data: id
        })
        .then(function (response) {
          return response.results;
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.getEligibleReturnFolders = function () {
        return HttpService.get({
          url: '/AccountReturns/EligibleFolders',
          cache: false
        })
        .then(function (response) {
          return response.results;
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.getReturnFolders = function () {
        $rootScope.$broadcast('showPageLoader', true);
        return HttpService.get({
          url: '/AccountReturns/ReturnFolders',
          cache: false
        })
        .then(function (response) {
          $rootScope.$broadcast('showPageLoader', false);
          return response.results;
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.getShippingAddresses = function () {
        $rootScope.$broadcast('showPageLoader', true);
        return HttpService.get({
          url: '/AccountGetUserShippingAddresses',
          cache: false
        })
        .then(function (response) {
          $rootScope.$broadcast('showPageLoader', false);
          return response.results;
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      return {
        getLinks: this.getLinks,
        initAccount: this.initAccount,
        setManagement: this.setManagement,
        getOrders: this.getOrders,
        getOrder: this.getOrder,
        getEligibleReturnFolders: this.getEligibleReturnFolders,
        getReturnFolders: this.getReturnFolders,
        getShippingAddresses: this.getShippingAddresses
      };
    }]);

})();
